document.addEventListener('DOMContentLoaded', function () {
    // Buscar el botón personalizado
    const openChatButton = document.getElementById('open-chat-button');

    // Asegurarse de que el botón existe
    if (openChatButton) {
        // Añadir el evento de clic al botón
        openChatButton.addEventListener('click', function () {
            toggleChat();
        });
    }

    // Botón del bloque de contacto
    const openChatButtonContact = document.getElementById('open-chat-button-contact');
    if (openChatButtonContact) {
        openChatButtonContact.addEventListener('click', function () {
            toggleChat();
        });
    }

    // Botón del bloque "Call an Expert"
    const openChatButtonExpert = document.getElementById('open-chat-button-expert');
    if (openChatButtonExpert) {
        openChatButtonExpert.addEventListener('click', function () {
            toggleChat();
        });
    }

    // Función para alternar el chat
    function toggleChat() {
        const iframe = document.getElementById('smartchat-iframe');
        const logoButton = document.getElementById('smartchat-logo-button');

        if (iframe && logoButton) {
            const isIframeVisible = iframe.style.display !== 'none';

            if (!isIframeVisible) {
                iframe.style.display = 'block';
                setTimeout(() => (iframe.style.opacity = '1'), 10);
                logoButton.classList.add('open');
                logoButton.style.transform = 'scale(1.1)';
                toggleIcons(logoButton, false);
            } else {
                iframe.style.opacity = '0';
                setTimeout(() => (iframe.style.display = 'none'), 300);
                logoButton.classList.remove('open');
                logoButton.style.transform = 'scale(1)';
                toggleIcons(logoButton, true);
            }
        }
    }

    // Función para alternar los íconos
    function toggleIcons(logoButton, showChatIcon) {
        const chatIcon = logoButton.querySelector('.chat-icon');
        const arrowIcon = logoButton.querySelector('.arrow-icon');

        if (chatIcon && arrowIcon) {
            chatIcon.style.display = showChatIcon ? 'block' : 'none';
            arrowIcon.style.display = showChatIcon ? 'none' : 'block';
        }
    }
});